import { useSession, signOut } from 'next-auth/react';
import { runInAction } from 'mobx';
import { useCustomerDataStore } from '@features/customerData/mobx/context/CustomerDataStoreProvider';
const useAuth = (): {
  createSession: () => void;
} => {
  const {
    data: session
  } = useSession();
  const {
    fetchAndPopulateCustomerDataStore,
    getCustomerFromSession,
    removeCustomerFromSession
  } = useCustomerDataStore();
  const handleSessionExistForSignedIn = async () => {
    if (session?.token.error === 'RefreshAccessTokenError') {
      if (typeof session.token.idToken === 'string') {
        signOut({
          callbackUrl: `/api/auth/logout?idToken=${session.token.idToken}`
        });
      } else {
        signOut();
      }
      await removeCustomerFromSession();
      return;
    }
    await runInAction(async () => {
      await fetchAndPopulateCustomerDataStore();
    });
  };
  const createSession = async () => {
    const expireTime = !!session && new Date(session.expires).getTime() || 0;
    const sessionExpired = Date.now() > expireTime;

    // session not fetched yet
    if (session === undefined) return;
    // session exists for user signed in, fetch data
    if (session && !sessionExpired) await handleSessionExistForSignedIn();
    // session exists for user signed in but expired, sign out and create anonymous session
    if (session && sessionExpired) {
      signOut({
        callbackUrl: `/api/auth/logout?idToken=${session.token.idToken}`
      });
      await removeCustomerFromSession();
    }
    // load cached data to customer store
    await getCustomerFromSession();
  };
  return {
    createSession
  };
};
export default useAuth;